<script>
import Layout from "../../layouts/main";
import Heading from "../../layouts/heading";
import appConfig from "@/app.config";
import api from "../../../api";

export default {
  page: {
    title: "Staff Aailability",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, Heading,
  },
  data() {
    return {
      members: [],
      practice_team: [],
      current_location: '',
      locations: [],
      page: {
        title: "Staff Availability",
        lastUpdated: '',
        addNewBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
        selectLocation: true
      },
      default_days: {
        mon: {
            am: 0,
            pm: 0
        },
        tue: {
            am: 0,
            pm: 0
        },
        wed: {
            am: 0,
            pm: 0
        },
        thu: {
            am: 0,
            pm: 0
        },
        fri: {
            am: 0,
            pm: 0
        },
        sat: {
            am: 0,
            pm: 0
        },
        sun: {
            am: 0,
            pm: 0
        }
      },
      render_flag: 0
    };
  },
  methods: {
    async getMembers() {
      return await new Promise((resolve)=>{
        api.get(`/api/cms/${this.currentCms.id}/categories`)
        .then((response) => {
          var practiceTeamCat = response.data.filter(x => x.name == 'Practice Team')[0];
            api.get(`/api/categories/${practiceTeamCat.id}/pages`)
            .then((response) => {
              resolve({members: response.data, practice_team: practiceTeamCat})
            }, (error) => {
              console.log(error);
            });
        }, (error) => {
          console.log(error);
        });
      });
    },
    updateAvailabilityCheck(member, day, time) {
      console.log(member.id)
      if(this.members.find(x => x.id == member.id).additionalProp1.availability.locations.filter(x => x.id == this.current_location.id)[0].days[day][time] < 2) {
        this.members.find(x => x.id == member.id).additionalProp1.availability.locations.filter(x => x.id == this.current_location.id)[0].days[day][time] += 1
      } else {
        this.members.find(x => x.id == member.id).additionalProp1.availability.locations.filter(x => x.id == this.current_location.id)[0].days[day][time] = 0;
      }

      var additional_prop = this.members.find(x => x.id == member.id).additionalProp1;

      api.patch('/api/pages/'+member.id, { additionalProp1: additional_prop })
      .then(() => { 
      }, (error) => {
        console.log(error);
      });

    },
    updateAvailabilityStatusCheck(member) {
      this.members.find(x => x.id == member.id).additionalProp1.availability.locations.filter(x => x.id == this.current_location.id)[0].status = !this.members.find(x => x.id == member.id).additionalProp1.availability.locations.filter(x => x.id == this.current_location.id)[0].status;
      var additional_prop = this.members.find(x => x.id == member.id).additionalProp1;

      api.patch('/api/pages/'+member.id, { additionalProp1: additional_prop })
      .then(() => { 
      }, (error) => {
        console.log(error);
      });
    },
    async updateLocation(val) {
      this.current_location = val;
      const { members, practice_team } = await this.getMembers();
      this.practice_team = practice_team;
      let temp_mem = await members.filter(x => x.additionalProp1.availability && x.additionalProp1.availability.locations && Array.isArray(x.additionalProp1.availability.locations) && x.additionalProp1.availability.locations.length)
      temp_mem = await temp_mem.filter(x => x.additionalProp1.availability.locations.filter(y => y.id == this.current_location.id) )
      for(let mem of temp_mem) {
        for(const loc of mem.additionalProp1.availability.locations) {
          if(!('status' in loc)) Object.assign(loc, {status: false})
          if(!('days' in loc)) Object.assign(loc, {days: this.default_days})
        }
      }
      this.members = temp_mem;
    },
    async getLocations() {
      var self = this;
      return await new Promise((resolve)=>{
        api.get(`/api/cms/${this.currentCms.id}/categories`)
        .then((response) => {
          var location_category = response.data.filter(x => x.name == 'Locations')[0];
            api.get(`/api/categories/${location_category.id}/pages`)
            .then((response) => {
              self.current_location = response.data[0].id;
              resolve(response.data)
            }, (error) => {
              console.log(error);
            });
        }, (error) => {
          console.log(error);
        });
      });
    },
  },
  async mounted() {
    this.locations = await this.getLocations();
    this.current_location = this.locations.length ? this.locations[0] : ''
  }
};
</script>

<template>
  <Layout>
    <Heading :page="page" :locations="locations" @location-updated="updateLocation" :current_location="current_location"></Heading>
    <div v-if="current_location && practice_team.additionalProp1 && practice_team.additionalProp1.groups">
      <div v-for="group in practice_team.additionalProp1.groups" v-bind:key="group.id" class="table-responsive mt-4 px-4">
        <table v-show="members.filter(x => x.additionalProp1.group == group.id && x.additionalProp1.availability.locations.filter(x => x.id == current_location.id).length).length" class="table table-bordered mb-0" style="background: white; text-align: center">
          <thead class="thead-light">
            <tr class="font-size-22">
              <th style="text-align: left">{{group.title}}</th>
              <th colspan="2">Mon</th>
              <th colspan="2">Tue</th>
              <th colspan="2">Wed</th>
              <th colspan="2">Thu</th>
              <th colspan="2">Fri</th>
              <th class="text-muted" colspan="2">Sat</th>
              <th class="text-muted" colspan="2">Sun</th>
            </tr>
            <tr>
              <th></th>
              <th>AM</th><th>PM</th>
              <th>AM</th><th>PM</th>
              <th>AM</th><th>PM</th>
              <th>AM</th><th>PM</th>
              <th>AM</th><th>PM</th>
              <th class="text-muted">AM</th><th class="text-muted">PM</th>
              <th class="text-muted">AM</th><th class="text-muted">PM</th>
            </tr>
          </thead>
          <tbody>
            <tr class="font-size-24" v-for="member in members.filter(x => x.additionalProp1.group == group.id && x.additionalProp1.availability.locations.filter(x => x.id == current_location.id).length)" v-bind:key="member.id">
              <td class="font-size-16 align-middle" style="text-align:left" scope="row">
                <input type="checkbox" :id="'staff-member-' + member.id" :checked="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].status"
                @change.stop="updateAvailabilityStatusCheck(member)"/>
                <span class="form-check-label ml-3 mb-2" :for="'staff-member-' + member.id">{{member.title}}</span>
              </td>
              <td @click="updateAvailabilityCheck(member, 'mon', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.mon.am == 1" class="ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.mon.am == 2" class="ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'mon', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.mon.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.mon.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'tue', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.tue.am == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.tue.am == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'tue', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.tue.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.tue.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'wed', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.wed.am == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.wed.am == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'wed', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.wed.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.wed.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'thu', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.thu.am == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.thu.am == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'thu', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.thu.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.thu.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'fri', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.fri.am == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.fri.am == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'fri', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.fri.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.fri.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'sat', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sat.am == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sat.am == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'sat', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sat.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sat.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'sun', 'am')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sun.am == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sun.am == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
              <td @click="updateAvailabilityCheck(member, 'sun', 'pm')">
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sun.pm == 1" class=" ri-check-line"></i>
                <i v-show="member.additionalProp1.availability.locations.filter(x => x.id == current_location.id)[0].days.sun.pm == 2" class=" ri-checkbox-blank-circle-line"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>


 </Layout>
</template>

<style scoped>
th {
  font-weight: 500;
}
</style>